import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gmail-signup-error',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './gmail-signup-error.component.html',
  styleUrl: './gmail-signup-error.component.scss',
})
export class GmailSignupErrorComponent {
  constructor(private router: Router) {}

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
